import React, { useCallback, useEffect, useState } from 'react';
import { ui } from './toolTheme';

const generate = (len, upper, lower, numbers, symbols) => {
  const pools = [];
  if (upper) pools.push('ABCDEFGHIJKLMNOPQRSTUVWXYZ');
  if (lower) pools.push('abcdefghijklmnopqrstuvwxyz');
  if (numbers) pools.push('0123456789');
  if (symbols) pools.push('!@#$%^&*()-_=+[]{};:,.?/');
  if (!pools.length) return '';
  const chars = pools.join('');

  let out = '';
  for (let i = 0; i < len; i += 1) {
    out += chars[Math.floor(Math.random() * chars.length)];
  }
  return out;
};

const PasswordGeneratorPage = ({ setPage }) => {
  const [length, setLength] = useState(16);
  const [upper, setUpper] = useState(true);
  const [lower, setLower] = useState(true);
  const [numbers, setNumbers] = useState(true);
  const [symbols, setSymbols] = useState(true);
  const [password, setPassword] = useState('');

  const regenerate = useCallback(() => {
    setPassword(generate(length, upper, lower, numbers, symbols));
  }, [length, upper, lower, numbers, symbols]);

  useEffect(() => {
    regenerate();
  }, [regenerate]);

  return (
    <main style={ui.page}>
      <div style={{ ...ui.container, maxWidth: 760 }}>
        <button onClick={() => setPage('/tools')} style={ui.backBtn}>← Back to Tools</button>

        <div style={ui.card}>
          <h1 style={ui.sectionTitle}>Password Generator</h1>
          <p style={ui.sectionSub}>Generate strong random passwords with custom rules.</p>
        </div>

        <div style={{ ...ui.card, marginTop: 18 }}>
          <div style={{ ...ui.textarea, ...ui.mono, fontSize: 15, wordBreak: 'break-all' }}>
            {password || 'Select at least one character type'}
          </div>

          <div style={{ marginTop: 12, display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 }}>
            <label style={{ color: '#cbd5e1', fontSize: 13 }}>Length: {length}
              <input type="range" min={6} max={64} value={length} onChange={(e) => setLength(Number(e.target.value))} style={{ width: '100%' }} />
            </label>
            <div />
            <label style={{ color: '#cbd5e1', fontSize: 13 }}><input type="checkbox" checked={upper} onChange={(e) => setUpper(e.target.checked)} /> Uppercase</label>
            <label style={{ color: '#cbd5e1', fontSize: 13 }}><input type="checkbox" checked={lower} onChange={(e) => setLower(e.target.checked)} /> Lowercase</label>
            <label style={{ color: '#cbd5e1', fontSize: 13 }}><input type="checkbox" checked={numbers} onChange={(e) => setNumbers(e.target.checked)} /> Numbers</label>
            <label style={{ color: '#cbd5e1', fontSize: 13 }}><input type="checkbox" checked={symbols} onChange={(e) => setSymbols(e.target.checked)} /> Symbols</label>
          </div>

          <div style={{ display: 'flex', gap: 10, marginTop: 14 }}>
            <button onClick={regenerate} style={ui.primaryBtn}>Generate New</button>
            <button onClick={() => navigator.clipboard.writeText(password || '')} style={ui.secondaryBtn}>Copy</button>
          </div>
        </div>
      </div>
    </main>
  );
};

export default PasswordGeneratorPage;
